import styled from 'styled-components';

const DropdownContainer = styled.div`
  background-color: #fff;
  border: 0;
  box-shadow: 0 13px 27px -5px rgb(50 50 93 / 25%), 0 8px 16px -8px rgb(0 0 0 / 30%),
    0 -6px 16px -6px rgb(0 0 0 / 3%);
  display: block;
  font-size: 14px;
  left: 50%;
  opacity: 0;
  padding: 40px;
  position: absolute;
  top: 70px;
  transform-origin: left;
  width: max-content;
  z-index: var(--z-modal);

  a:hover {
    color: var(--darkest);
  }

  li:hover,
  .simple-nav-item:hover {
    background: var(--titan-blue-hover) !important;
    cursor: pointer;
  }

  &.open {
    display: block;
    opacity: 1;
    transform: translateX(-50%);
    transition: visibility 0.5s, opacity 0.5s, transform 0.5s;
    visibility: visible;

    .slick-active {
      opacity: 1;
      visibility: visible !important;
      transition: visibility 0.5s, opacity 0.5s, transform 0.5s;
    }
  }

  &.closed {
    opacity: 0;
    -webkit-transform: perspective(999px) rotateX(-10deg) translateZ(0) translate3d(-50%, 15px, 0);
    transform: perspective(999px) rotateX(-10deg) translateZ(0) translate3d(-50%, 15px, 0);
    visibility: hidden;
    pointer-events: none;

    .slick-active {
      opacity: 0;
      visibility: hidden !important;
      transition: visibility 0.5s, opacity 0.5s, transform 0.5s;
    }
  }

  .header-menu-arrow {
    width: 100%;
    position: absolute;
    height: 15px;
    top: -15px;
    left: 0;

    &:before {
      border-bottom: 11px solid var(--white);
      border-left: 11px solid transparent;
      border-right: 11px solid transparent;
      content: '';
      display: inline-block;
      left: 0;
      margin-left: auto;
      margin-right: auto;
      position: absolute;
      right: 0;
      top: 5px;
      width: 1px;
    }
  }

  &.products-menu-modal {
    width: 420px;
  }

  &.solutions-menu-modal {
    padding: 0;

    .header-menu-arrow {
      &:before {
        border-bottom: 12px solid var(--white);
      }
    }
  }

  &.resources-menu-modal {
    padding: 40px 40px 35px 40px;

    .header-menu-arrow {
      &:before {
        border-bottom: 12px solid var(--white);
      }
    }
  }

  &.trades {
    padding-right: 60px;

    .header-menu-cta {
      width: calc(100% + 20px);
    }
  }

  &.why-servicetitan {
    padding-right: 50px;
  }
`;

export { DropdownContainer };
